import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";
import { TransferenciaRequest } from "@/shared/types/transferencia";

export interface CajaMovimientoRequest {
    fecha: string,
    descripcion: string,
    transferencia: TransferenciaRequest
}

export async function addCajaMovimiento(request: CajaMovimientoRequest): Promise<CajaMovimiento> {
    await sleep(1000);
    const response = await api.post("caja_actual/open/details", request);
    return response.data;
}

export function useAddCajaMovimientoMutation(mutationConfig: MutationConfig<CajaMovimiento, CajaMovimientoRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addCajaMovimiento,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["caja_actual", "open", "details"] });
        },
    })
}

export interface AddCajaMovimientoMutationProps {
    mutationConfig?: MutationConfig<CajaMovimiento, CajaMovimientoRequest>
    children?: (mutationResult: MutationResult<CajaMovimiento, CajaMovimientoRequest>) => ReactNode
}

export function AddCajaMovimientoMutation({
    mutationConfig,
    children
}: AddCajaMovimientoMutationProps) {
    const mutationResult = useAddCajaMovimientoMutation(mutationConfig);
    return children && children(mutationResult);
}